<div class="obv" [class.is-desligado]="!exibir">

  <div class="obv-bar">
    <div class="obv-tit">
      <span class="obv-marca"><i class="fas fa-bullhorn"></i></span>
      <h3>Ofertas de boas-vindas</h3>
    </div>
    <button type="button" class="obv-x" (click)="feche()" aria-label="Fechar">
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="obv-corpo">

    <div class="obv-config">

      <div class="obv-liga">
        <div class="obv-liga__txt">
          <strong>Mostrar ofertas quando o cliente abre o cardápio</strong>
          <span>Uma única vez por dia para cada cliente.</span>
        </div>
        <button type="button" class="obv-sw" role="switch"
                [class.is-on]="exibir"
                [attr.aria-checked]="exibir"
                [disabled]="salvando"
                (click)="alterneExibicao()"
                aria-label="Mostrar ofertas na abertura"></button>
      </div>

      <div class="obv-erro" *ngIf="erro">
        <i class="fa fa-exclamation-circle"></i> {{erro}}
      </div>

      <div class="obv-desliga-junto">

        <div class="obv-campo" *ngIf="temRecursoVitrines">
          <span class="obv-rot">O que aparece</span>
          <div class="obv-opcoes">
            <button type="button" class="obv-opcao" [class.is-on]="fonte === 'auto'"
                    [disabled]="salvando" (click)="useFonte('auto')">
              <strong>Produtos em destaque</strong>
              <span>Os que você já marcou como destaque no catálogo</span>
            </button>
            <button type="button" class="obv-opcao" [class.is-on]="fonte === 'vitrine'"
                    [disabled]="salvando || !vitrines.length" (click)="useFonte('vitrine')">
              <strong>Uma vitrine</strong>
              <span>Você escolhe a lista, na ordem que montou</span>
            </button>
          </div>
        </div>

        <div class="obv-campo" *ngIf="temRecursoVitrines && fonte === 'vitrine'">
          <span class="obv-rot">Qual vitrine</span>
          <select class="obv-select" [ngModel]="vitrineId" [disabled]="salvando"
                  (ngModelChange)="useVitrine($event)" aria-label="Vitrine exibida na abertura">
            <option *ngFor="let vitrine of vitrines" [ngValue]="vitrine.id">{{vitrine.nome}}</option>
          </select>
        </div>

        <div class="obv-campo">
          <span class="obv-rot">Formato no celular</span>
          <div class="obv-opcoes">
            <button type="button" class="obv-opcao" [class.is-on]="formato === 'SHEET'"
                    [disabled]="salvando" (click)="useFormato('SHEET')">
              <strong>Desliza de baixo</strong>
              <span>O cardápio continua visível atrás</span>
            </button>
            <button type="button" class="obv-opcao" [class.is-on]="formato === 'DIALOG'"
                    [disabled]="salvando" (click)="useFormato('DIALOG')">
              <strong>Janela central</strong>
              <span>Escurece o fundo e chama mais atenção</span>
            </button>
          </div>
        </div>

        <div class="obv-regras">
          <h4>Quando não aparece</h4>
          <ul>
            <li><i class="fa fa-check"></i> Depois da primeira vez no dia, para o mesmo cliente.</li>
            <li><i class="fa fa-check"></i> Quando o cliente chega por um link direto de produto — ele já sabe o que quer.</li>
            <li><i class="fa fa-check"></i> Quando já existe pedido em andamento na sacola.</li>
            <li><i class="fa fa-check"></i> Nos fluxos de mesa, que têm avisos próprios.</li>
            <li><i class="fa fa-check"></i> Quando não há nenhuma oferta para mostrar.</li>
          </ul>
        </div>

      </div>
    </div>

    <div class="obv-previa">
      <span class="obv-rot">Prévia · celular</span>

      <div class="obv-fone" [class.is-dialog]="formato === 'DIALOG'">
        <div class="obv-fone__topo"><span>CARDÁPIO</span></div>

        <div class="obv-fundo">
          <div class="obv-fundo__chips">
            <span></span><span></span><span></span>
          </div>
          <div class="obv-fundo__linha" *ngFor="let linha of [1,2,3,4]">
            <span class="obv-fundo__foto"></span>
            <span class="obv-fundo__txt"><i></i><i></i></span>
          </div>
        </div>

        <div class="obv-folha" *ngIf="exibir && ofertas.length">
          <span class="obv-alca"></span>

          <div class="obv-folha__topo">
            <span class="obv-pill">
              <i class="fa fa-tag"></i>
              {{totalOfertas}} {{totalOfertas === 1 ? 'oferta' : 'ofertas'}} de hoje
            </span>
            <i class="fa fa-times obv-folha__x"></i>
          </div>

          <div class="obv-folha__tit">Aproveite antes de fechar o pedido</div>
          <div class="obv-folha__sub" *ngIf="economiaTotal > 0">
            Você economiza até <b>{{economiaTotal | currency: 'BRL'}}</b> nos itens abaixo.
          </div>

          <div class="obv-itens">
            <div class="obv-item" *ngFor="let produto of ofertas">
              <div class="obv-item__txt">
                <span class="obv-item__nome">{{produto.nome}}</span>
                <span class="obv-item__desc" *ngIf="descricaoCurta(produto)">{{descricaoCurta(produto)}}</span>
                <span class="obv-precos">
                  <span class="obv-preco">{{obtenhaPreco(produto) | currency: 'BRL'}}</span>
                  <span class="obv-preco-velho" *ngIf="percentualDesconto(produto) > 0">
                    {{produto.precoAntigo | currency: 'BRL'}}
                  </span>
                </span>
              </div>
              <div class="obv-foto" *ngIf="temImagem(produto)">
                <img [src]="obtenhaImagem(produto)" alt="" (error)="marqueImagemComErro(produto)"/>
                <span class="obv-selo" *ngIf="percentualDesconto(produto) > 0">
                  -{{percentualDesconto(produto)}}%
                </span>
              </div>
            </div>
          </div>

          <div class="obv-folha__rodape">Ver todas as ofertas do cardápio ›</div>
        </div>
      </div>

      <p class="obv-nota" *ngIf="!exibir">
        Nada é exibido: o cliente cai direto no cardápio.
      </p>
      <p class="obv-nota" *ngIf="exibir && ofertas.length && formato === 'SHEET'">
        O cardápio continua visível atrás da folha — o cliente entende que é só um aviso.
      </p>
      <p class="obv-nota" *ngIf="exibir && ofertas.length && formato === 'DIALOG'">
        O fundo escurece e a janela fica no centro: chama mais atenção, interrompe mais.
      </p>

      <p class="obv-nota obv-nota--alerta" *ngIf="exibir && !ofertas.length && !carregandoVitrines">
        <ng-container *ngIf="vitrineEscolhidaVazia">
          Esta vitrine está vazia ou indisponível, então nada será exibido.
        </ng-container>
        <ng-container *ngIf="!vitrineEscolhidaVazia">
          Nenhum produto em destaque no catálogo, então nada será exibido. Marque produtos
          como destaque para as ofertas aparecerem.
        </ng-container>
      </p>
    </div>

  </div>

  <div class="obv-rodape">
    <span class="obv-salvo" *ngIf="!salvando && !erro">
      <i class="fa fa-check"></i> Alterações salvas automaticamente
    </span>
    <span class="obv-salvo obv-salvo--indo" *ngIf="salvando">
      <i class="fa fa-spinner fa-spin"></i> Salvando…
    </span>
    <span *ngIf="!salvando && erro"></span>
    <button type="button" class="obv-btn" (click)="feche()">Concluir</button>
  </div>

</div>
